'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _urls = require('../urls');

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');
var service = _abp2.default.services.api.search;
var cache = {};
var expire = 60000; // ms
var delay = 300; // ms
var maxItems = 5;
var minimumChars = 3; // minimum amount of characters you need to write to get suggestion
var loadingHandle = 0;

function skEnvironment() {
    return window.document.body.classList.contains('sk');
}

var SearchControl = function (_React$Component) {
    (0, _inherits3.default)(SearchControl, _React$Component);

    function SearchControl(props) {
        (0, _classCallCheck3.default)(this, SearchControl);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchControl.__proto__ || (0, _getPrototypeOf2.default)(SearchControl)).call(this, props));

        _this.searchClick = function (e) {
            e.preventDefault();
            _this.search();
        };

        _this.onFocus = function (e) {
            _this.setState((0, _extends3.default)({}, _this.state, { placeHolderHideClass: 'hide-placeholder' }));
        };

        _this.onBlur = function (e) {
            if (e.target.value.length === 0) {
                _this.setState((0, _extends3.default)({}, _this.state, { placeHolderHideClass: '' }));
            }
        };

        _this.onChange = function (e) {
            var phrase = e.target.value;

            _this.setState((0, _extends3.default)({}, _this.state, { value: phrase }));
            setTimeout(function () {
                if (phrase.length < minimumChars) _this.close();
            }, 0);
            getSuggestionsFor(phrase, function (result) {
                _this.setState((0, _extends3.default)({}, _this.state, { result: result, index: -1 }));
            });
        };

        _this.onKeyUp = function (e) {
            var _this$state = _this.state,
                index = _this$state.index,
                result = _this$state.result;

            if (e.key === 'Escape') {
                if (index >= 0) {
                    _this.setState((0, _extends3.default)({}, _this.state, { index: -1 }));
                } else {
                    _this.close();
                }
            } else if (e.key === 'ArrowUp') {
                if (index >= 0) {
                    _this.setState((0, _extends3.default)({}, _this.state, { index: index - 1 }));
                }
            } else if (e.key === 'ArrowDown') {
                if (result && result.products && result.products.length > index + 1) {
                    _this.setState((0, _extends3.default)({}, _this.state, { index: index + 1 }));
                }
            }
        };

        _this.onKeyDown = function (e) {
            var _this$state2 = _this.state,
                index = _this$state2.index,
                result = _this$state2.result;

            if (e.key === 'Enter') {
                if (index >= 0) {
                    var item = result && result.products && result.products[index];
                    var url = item && item.detailUrl;
                    if (url) {
                        window.location.href = url;
                        e.preventDefault();
                    }
                } else {
                    _this.search();
                }
            }
        };

        _this.state = {
            placeHolderHideClass: '',
            value: '',
            result: null,
            index: -1
        };
        return _this;
    }

    (0, _createClass3.default)(SearchControl, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            (0, _jquery2.default)(document).on('click', function (e) {
                if (_this2.state.result && !(0, _jquery2.default)(e.target).closest('.suggesttion__wrap').length) {
                    _this2.close();
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                result = _state.result,
                value = _state.value,
                index = _state.index;

            var products = result && result.products || [];
            var authors = result && result.authors || [];

            var showSuggestions = !!(products.length || authors.length);
            var showProducts = !!products.length;
            var showAuthors = !!authors.length;
            var wrapClass = "suggesttion__wrap";
            if (showSuggestions) {
                wrapClass += " suggesttion__wrap--open";
            }
            return _react2.default.createElement(
                'div',
                { className: wrapClass },
                _react2.default.createElement(
                    'span',
                    { className: 'custom-placeholder__wrap' },
                    _react2.default.createElement('input', { type: 'text', name: 'Text', autoComplete: 'off', className: 'select input-search ' + this.state.placeHolderHideClass,
                        value: value || '',
                        onChange: this.onChange,
                        onKeyUp: this.onKeyUp,
                        onFocus: this.onFocus,
                        onBlur: this.onBlur,
                        onKeyDown: this.onKeyDown }),
                    _react2.default.createElement(
                        'span',
                        { className: 'custom-placeholder__text' },
                        Resx.Common.SearchInputPlaceholder
                    )
                ),
                _react2.default.createElement(
                    'button',
                    { onClick: this.searchClick },
                    _react2.default.createElement('i', { className: 'icon--search' })
                ),
                showSuggestions && _react2.default.createElement(
                    'div',
                    { className: 'suggestions' },
                    showProducts && _react2.default.createElement(
                        'div',
                        { className: 'suggested-products' },
                        _react2.default.createElement(
                            'a',
                            { href: '#', className: 'suggestions__close', onClick: function onClick(e) {
                                    e.preventDefault();_this3.close();
                                } },
                            _react2.default.createElement('i', { className: 'icon--cross' })
                        ),
                        products.map(function (p, i) {
                            return _react2.default.createElement(SuggestedProduct, (0, _extends3.default)({ key: p.id }, p, { selected: i === index }));
                        }),
                        products.length === maxItems && /* fake info about total count */
                        _react2.default.createElement(
                            'div',
                            { className: 'sugg-prod__item text-center pb-3 pt-3' },
                            _react2.default.createElement(
                                'a',
                                { className: 'btn btn--sm', href: '', onClick: this.searchClick },
                                Resx.App.ShowSearchResults
                            )
                        )
                    ),
                    showAuthors && _react2.default.createElement(
                        'div',
                        { className: 'suggested-authors' },
                        _react2.default.createElement(
                            'div',
                            { className: 'suggested-authors__title' },
                            Resx.Common.Authors,
                            ':'
                        ),
                        authors.map(renderAuthor)
                    )
                )
            );
        }
    }, {
        key: 'search',
        value: function search() {
            var value = this.state.value;

            if (value) {
                window.location.href = (0, _urls2.default)('search') + '?Text=' + encodeURIComponent(value) + '&filter=' + encodeURIComponent('"notonlypurchasable":true');
            }
        }
    }, {
        key: 'close',
        value: function close() {
            this.setState((0, _extends3.default)({}, this.state, { result: null, index: -1 }));
        }
    }]);
    return SearchControl;
}(_react2.default.Component);

var SuggestedProduct = function (_React$Component2) {
    (0, _inherits3.default)(SuggestedProduct, _React$Component2);

    function SuggestedProduct(props) {
        (0, _classCallCheck3.default)(this, SuggestedProduct);

        var _this4 = (0, _possibleConstructorReturn3.default)(this, (SuggestedProduct.__proto__ || (0, _getPrototypeOf2.default)(SuggestedProduct)).call(this, props));

        _this4.onImageError = function () {
            _this4.setState({ imageUrl: '/Content/images/img-placeholder-big.jpg' });
        };

        _this4.state = { imageUrl: null };
        return _this4;
    }

    (0, _createClass3.default)(SuggestedProduct, [{
        key: 'flag',
        value: function flag() {
            var language = this.props.language;

            if (!(language === 'cz' && !skEnvironment())) {
                // vlajku nezobrazujeme pouze v CR pokud se jedna o CZ knihu
                return _react2.default.createElement('img', { className: 'sugg-prod-i__flag', src: '/Content/images/svg/flags/4x3/' + language + '.svg', alt: language });
            }
            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                detailUrl = _props.detailUrl,
                thumbnailUrl = _props.thumbnailUrl,
                name = _props.name,
                price = _props.price,
                availability = _props.availability,
                discount = _props.discount,
                selected = _props.selected,
                dispatchDate = _props.dispatchDate,
                upcomingDate = _props.upcomingDate;

            var dispatchDateAsDate = dispatchDate ? new Date(dispatchDate) : null;
            var upcomingDateAsDate = upcomingDate ? new Date(upcomingDate) : null;
            var dispatchText = availability === _linksoftAlbatros.ProductAvailability.ExactDelivery && dispatchDateAsDate ? (0, _linksoftAlbatros.format)(dispatchDateAsDate, 'd') : null;
            var upcomingText = availability === _linksoftAlbatros.ProductAvailability.ExactDelivery && upcomingDateAsDate ? (0, _linksoftAlbatros.format)(upcomingDateAsDate, 'd') : null;
            var availabilityText = (0, _linksoftAlbatros.getAvailabilityText)(availability, false).replace('{0:d}', upcomingText != null ? upcomingText : dispatchText);
            var className = 'sugg-prod__item sugg-prod-i';
            if (selected) {
                className += ' sugg-prod__item--selected';
            }
            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'a',
                    { className: 'sugg-prod-i__inner', href: detailUrl },
                    _react2.default.createElement(
                        'span',
                        { className: 'sugg-prod-i__img' },
                        _react2.default.createElement('img', { src: this.state.imageUrl || thumbnailUrl, onError: this.onImageError }),
                        ' '
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'sugg-prod-i__infos' },
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(
                                'strong',
                                { className: 'sugg-prod-i__name' },
                                name
                            ),
                            ' ',
                            this.flag(),
                            !!availabilityText && _react2.default.createElement(
                                'i',
                                null,
                                availabilityText
                            ),
                            ' '
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'sugg-prod-i__price' },
                            _react2.default.createElement(
                                'span',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'price__actual' },
                                    (0, _linksoftAlbatros.formatPrice)(price, _linksoftAlbatros.PriceType.CatalogUnitPrice)
                                ),
                                ' '
                            )
                        )
                    )
                )
            );
        }
    }]);
    return SuggestedProduct;
}(_react2.default.Component);

function renderAuthor(author) {
    return _react2.default.createElement(
        'div',
        { className: 'suggested-author', key: author.id },
        _react2.default.createElement(
            'a',
            { href: (0, _urls2.default)('author', author) },
            author.name
        )
    );
}

function getSuggestionsFor(phrase, cb) {
    setTimeout(function () {
        if (typeof phrase !== 'string' || phrase.trim().length < minimumChars) {
            cb(null);
            return;
        }
        // try to get from cache
        var cacheKey = phrase.toLowerCase();
        var cachedValue = cache[cacheKey];
        if (cachedValue) {
            if (cachedValue.ts + expire >= new Date().getTime()) {
                cb(cachedValue.result);
                return;
            } else {
                delete cache[cacheKey];
            }
        }

        // load from service
        if (loadingHandle) {
            clearTimeout(loadingHandle);
        }
        loadingHandle = setTimeout(function () {
            loadingHandle = 0;

            service.suggest(phrase).done(function (result) {
                cache[cacheKey] = {
                    ts: new Date().getTime(),
                    result: result
                };
                cb(result);
            });
        }, delay);
    }, 0);
}

exports.default = SearchControl;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/modules/SearchControl.js
// module id = 1088
// module chunks = 0